import { defineStore } from 'pinia'
import { ref, type Ref } from 'vue'

import { AllowedPages } from '@/enums/allowedPages'
import { useAppStore } from '@/stores/app'
import { useFetchStore } from '@/stores/fetch'

export const useNotificationStore = defineStore('notification', () => {
    const appStore = useAppStore()
    const unreadNotifications: Ref<number> = ref(0)

    const setUnreadNotifications = (unreadNotification: number) => {
        unreadNotifications.value = unreadNotification
    }

    const getUnreadNotifications = () => {
        return unreadNotifications.value
    }

    const updateUnreadNotifications = () => {
        if (!appStore.getUserLoggedIn() || !appStore.getAllowedPages().includes(AllowedPages.Notifications)) return

        const fetchStore = useFetchStore()
        void fetchStore.fetch('/api/iiportal-user/v2/notifications/unread_num').get().json<{ unread_num: number }>().then(({ data }) => {
            if (data.value) setUnreadNotifications(data.value.unread_num)
        })
    }

    return {
        unreadNotifications,
        setUnreadNotifications,
        getUnreadNotifications,
        updateUnreadNotifications
    }
})
